'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _Model = require('../model/Model');

var _Model2 = _interopRequireDefault(_Model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var I18n = function () {
  function I18n(model) {
    _classCallCheck(this, I18n);

    this.defaultLocale = '';
    this.locale = '';

    this.model = model ? model : new _Model2.default();
  }

  _createClass(I18n, [{
    key: 'getActiveLocale',
    value: function getActiveLocale() {
      return this.model.getActiveLocale();
    }
  }, {
    key: 'setActiveLocale',
    value: function setActiveLocale(locale) {
      return this.model.setActiveLocale(locale);
    }
  }, {
    key: 't',
    value: function t(scope, option) {
      var result = this.model.getText(scope, option) || scope;
      return this._serializeText(result, option);
    }
  }, {
    key: 'lt',
    value: function lt(scope, option) {
      var _this = this;

      return this.model.loadText(scope, option).then(function (result) {
        return _this._serializeText(result, option);
      });
    }
  }, {
    key: 'addLanguageScope',
    value: function addLanguageScope(language, textByScope) {
      this.model.addLanguageScope(language, textByScope);
      return this;
    }
  }, {
    key: '_serializeText',
    value: function _serializeText(text) {
      var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (option.variables) {
        return text.replace(/{{(.*)}}/g, function (match, param) {
          return (0, _get2.default)(option.variables, param, param);
        });
      }
      return text;
    }
  }]);

  return I18n;
}();

exports.default = I18n;
module.exports = exports['default'];